<template>
    <div :class="this.$lang() == 1 ? 'container_header_zh' : 'container_header'">
        <div class="invoice-header">
            <div class="invoice-header-left">
                <div class="invoice-header-left_area-code" style="margin-top: 0;">
                    <span>{{ $t("new.title277") }}:</span>
                    <span>{{ outlineInfo.code }}</span>
                </div>
                <div class="invoice-header-left_area-code">
                    <span>{{ $t("new.title258") }}:</span>
                    <span>&nbsp; {{ bank[0].numberBank }}</span>
                </div>
                <div class="invoice-header-left_person">
                    <span>{{ outlineInfo.name }}</span>
                    <span> &nbsp;{{ $t("new.title259") }}</span>
                </div>
            </div>
            <div class="invoice-header-right">
                <div class="invoice-header-right_content">
                    <div class="invoice-header-right_date">
                        <span>{{ $t("new.title260") }}：{{ days.year }}{{ $t("new.title261") }}&nbsp;{{ days.month }}{{ $t("new.title262") }}&nbsp;{{ days.day }}{{ $t("new.title263") }}</span>
                    </div>
                    <div class="invoice-header-right_info-company">
                        <div class="invoice-header-right_info-company_content">
                            <div class="invoice-header-right_company-name">
                                <span>東京三立学院</span>
                            </div>
                            <div class="invoice-header-right_postal-code">
                                <span>〒</span>
                                <span>168-0074</span>
                            </div>
                            <div class="invoice-header-right_address">
                                <span>東京都杉並区上高井戸1-3-14</span>
                            </div>
                            <div class="invoice-header-right_tel">
                                <span>Tel:</span>
                                <span>03-3304-4560</span>
                            </div>
                            <div class="invoice-header-right_fax">
                                <span>Fax:</span>
                                <span>03-3304-4561</span>
                            </div>
                        </div>
                        <div class="invoice-header-right_img">
                            <img src="@/assets/WechatPay/imprint.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: {
        bank: Array,
    },
    data () {
        return {
            outlineInfo: this.$route.query,
            days: {
                day: "",
                month: "",
                year: ""
            },
        }
    },
    created() {
        this.getCurrentDay()
    },
    watch : {
        getDataInsert(value) {
            this.outlineInfo = this.$route.query
        },
        getCode(value) {
            this.outlineInfo = this.$route.query
            this.outlineInfo.code = value
        }
    },
    methods: {
        getCurrentDay () {
            const date = new Date()
            this.days.day = date.getDate()
            this.days.month = date.getMonth() + 1
            this.days.year = date.getFullYear(  )
        }
    },
    computed: {
        ...mapGetters('applyCourse', ['getDataInsert', "getCode"]),
    }
}
</script>
<style scoped>
.invoice-header {
    display: flex;
    justify-content: space-between;
}
.container_header_zh span{
    font-size: 15px;
    font-weight: bold;
    font-family: 'Microsoft JhengHei', sans-serif !important;
}
.container_header span{
    font-size: 16.3px;
    font-family: 'MS Gothic', sans-serif !important;
}
.invoice-header-left {
    display: flex;
    flex-direction: column;
}

.invoice-header-right {
    text-align: right;
}

.invoice-header-right_date {
    text-align: right;
}

.invoice-header-left_area-code {
    align-items: center;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
}

.invoice-header-left_person {
    display: flex;
    margin-top: 5px;
    justify-content: space-between;
    align-items: center;
}

.invoice-header-right_info-company {
    position: relative;
    margin-top: 45px;
    display: flex;
    flex-direction: column;
    align-items: end;
}

.invoice-header-right_company-name {
    margin-top: 9px;
}

.invoice-header-right_postal-code {
    margin-top: 4px;
}

.invoice-header-right_address {
    margin-top: 4px;
}

.invoice-header-right_tel {
    margin-top: 6px;
}

.invoice-header-right_fax {
    margin-top: 9px;
}

.invoice-header-right_img {
    position: absolute;
    z-index: -1;
    top: 55%;
    left: 65%;
    transform: translate(-35%, -45%);
}

.invoice-header-right_img img {
    width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/exportInfoInvoiceToPdf/headerPdf.vue